import { Widget } from '@typeform/embed-react'
import { Flex, FlexProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useProduct } from '../product/productContext'

export const TypeformSurvey: FunctionComponent<FlexProps> = (props) => {
  const {
    product: { typeformSurveyId },
  } = useProduct()

  return typeformSurveyId ? (
    <Flex variant='raised' backgroundColor='background' width={1} {...props}>
      <Widget id={typeformSurveyId} style={{ width: '100%', height: '500px' }} />
    </Flex>
  ) : null
}
